var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9702 3.12245C27.8076 2.51841 27.4893 1.96767 27.0469 1.52534C26.6046 1.08302 26.0539 0.764629 25.4498 0.602041C23.2253 2.38419e-07 14.2866 0 14.2866 0C14.2866 0 5.34779 2.38419e-07 3.1233 0.602041C2.51926 0.764629 1.96851 1.08302 1.52619 1.52534C1.08387 1.96767 0.765477 2.51841 0.602888 3.12245C0.18675 5.39098 -0.0148204 7.69367 0.000847661 10C-0.0148204 12.3063 0.18675 14.609 0.602888 16.8776C0.765477 17.4816 1.08387 18.0323 1.52619 18.4747C1.96851 18.917 2.51926 19.2354 3.1233 19.398C5.34779 20 14.2866 20 14.2866 20C14.2866 20 23.2253 20 25.4498 19.398C26.0539 19.2354 26.6046 18.917 27.0469 18.4747C27.4893 18.0323 27.8076 17.4816 27.9702 16.8776C28.3864 14.609 28.5879 12.3063 28.5723 10C28.5879 7.69367 28.3864 5.39098 27.9702 3.12245ZM11.4294 14.2857V5.71429L18.8478 10L11.4294 14.2857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.70b9f7cc6cdfb77e6ccbcfd6d81e3c8c.svg";
export { ForwardRef as ReactComponent };